import { render } from "./PostComment.vue?vue&type=template&id=a8d06866&scoped=true"
import script from "./PostComment.vue?vue&type=script&lang=js"
export * from "./PostComment.vue?vue&type=script&lang=js"

import "./post-comment.scss?vue&type=style&index=0&id=a8d06866&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8d06866"]])

export default __exports__